import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const DownloadIcon: FunctionComponent<IconProps> = ({ size }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size ? size : 24}
    height={size ? size : 24}
    fill='none'
    viewBox='0 0 16 16'
  >
    <path
      fill='currentColor'
      d='M8 11.575c-.133 0-.258-.021-.375-.063A.871.871 0 0 1 7.3 11.3L3.7 7.7a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7.183-.183.42-.28.712-.288.292-.008.53.08.713.263L7 8.15V1c0-.283.096-.521.288-.713A.967.967 0 0 1 8 0a.97.97 0 0 1 .713.287A.97.97 0 0 1 9 1v7.15l1.875-1.875c.183-.183.421-.271.713-.263.291.009.529.105.712.288a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7l-3.6 3.6c-.1.1-.208.17-.325.212a1.099 1.099 0 0 1-.375.063ZM2 16c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 0 14v-2a.97.97 0 0 1 .287-.713A.97.97 0 0 1 1 11a.97.97 0 0 1 .713.287A.97.97 0 0 1 2 12v2h12v-2c0-.283.096-.521.288-.713A.967.967 0 0 1 15 11c.283 0 .52.096.712.287.192.192.288.43.288.713v2c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 14 16H2Z'
    />
  </svg>
)

export default DownloadIcon;
